import React from 'react';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {router} from '@/router';
import ErrorPage from '@/components/pages/error_pages/ErrorPage';
import {ErrorCenter} from '@/components/pages/error_pages/ErrorPage.styles';

export default function FailedPhoneVerification() {
  return (
    <ErrorPage title="Error! The phone number you have entered does not match our records.">
      <span>Please contact your account manager.</span>
      <ErrorCenter>
        <Button onClick={() => router.navigate('/')} styleType={StyleType.SECONDARY}>
          Return to Login
        </Button>
      </ErrorCenter>
    </ErrorPage>
  );
}
